<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">View</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <data-detail-row
            label="Bill Number"
            :data="editedItem"
            :valueData="editedItem.bill_number"
            noGutters
          />
          <data-detail-row
            label="Aggregator Name"
            :data="editedItem"
            :valueData="editedItem.aggregator_name"
            noGutters
          />
          <data-detail-row
            label="Merchant Name"
            :data="editedItem"
            :valueData="editedItem.merchant_name"
            noGutters
          />
          <data-detail-row
            label="MID"
            :data="editedItem"
            :valueData="editedItem.mid"
            noGutters
          />
          <data-detail-row
            label="Merchant PAN"
            :data="editedItem"
            :valueData="editedItem.mpan"
            noGutters
          />
          <data-detail-row
            label="Reff ID"
            :data="editedItem"
            :valueData="editedItem.rrn"
            noGutters
          />
          <data-detail-row
            label="QR Method"
            :data="editedItem"
            :valueData="editedItem.qr_method"
            noGutters
          />
          <data-detail-row
            v-if="shouldShowAmountType"
            label="Amount Type"
            :data="editedItem"
            :valueData="editedItem.amount_type"
            noGutters
          />
          <data-detail-row
            label="QR Type"
            :data="editedItem"
            :valueData="editedItem.qr_type"
            noGutters
          />
          <data-detail-row
            label="Transaction Type"
            :data="editedItem"
            :valueData="editedItem.trx_type"
            noGutters
          />
          <data-detail-row
            label="Issuer Name"
            :data="editedItem"
            :valueData="editedItem.issuer_name"
            noGutters
          />
          <data-detail-row
            label="Customer PAN"
            :data="editedItem"
            :valueData="editedItem.customer_pan"
            noGutters
          />
          <data-detail-row
            label="Source of Fund"
            :data="editedItem"
            :valueData="editedItem.payment_method"
            noGutters
          />
          <data-detail-row
            label="Customer Name"
            :data="editedItem"
            :valueData="editedItem.customer_name"
            noGutters
          />
          <data-detail-row
            label="Payment Type"
            :data="editedItem"
            :valueData="editedItem.payment_type"
            noGutters
          />
          <data-detail-row
            label="Acquirer Name"
            :data="editedItem"
            :valueData="editedItem.payment_channel"
            noGutters
          />
          <data-detail-row
            label="Amount"
            :data="editedItem"
            :valueData="editedItem.amount"
            noGutters
          />
          <data-detail-row
            label="MDR"
            :data="editedItem"
            :valueData="editedItem.amount_mdr"
            noGutters
          />
          <data-detail-row
            label="Net Amount"
            :data="editedItem"
            :valueData="editedItem.net_amount"
            noGutters
          />
          <data-detail-row
            label="Amount Fee"
            :data="editedItem"
            :valueData="editedItem.amount_fee"
            noGutters
          />
          <data-detail-row
            label="Transaction Date"
            :data="editedItem"
            :valueData="editedItem.trx_datetime"
            noGutters
          />
          <data-detail-row
            label="Status"
            :data="editedItem"
            :valueData="editedItem.status"
            noGutters
          />
          <data-detail-row
            label="Settlement Status"
            :data="editedItem"
            :valueData="editedItem.settlement_status"
            noGutters
          />
          <data-detail-row
            label="Additional Data"
            :data="editedItem"
            :valueData="editedItem.additional_data"
            noGutters
          />

          <div v-if="editedItem.tap_data && editedItem.product_indicator !== 'N001'" class="mt-6 tap-data-wrapper">
            <v-divider class="mb-4"></v-divider>
            
            <!-- TAP IN -->
            <v-card class="mb-4 tap-card" outlined>
              <v-card-text class="pa-4">
                <div class="primary--text mb-1 tap-label">TAP IN</div>
                <div class="tap-row">
                  <span class="tap-label">Reff ID :</span>
                  <span class="tap-value">{{ editedItem.tap_data.tap_in?.rrn || '-' }}</span>
                </div>
                <div class="tap-row">
                  <span class="tap-label">Transaction Date :</span>
                  <span class="tap-value">{{ editedItem.tap_data.tap_in?.trx_datetime || '-' }}</span>
                </div>
                <div class="tap-row">
                  <span class="tap-label">Amount :</span>
                  <span class="tap-value">{{ editedItem.tap_data.tap_in?.amount || '-' }}</span>
                </div>
              </v-card-text>
            </v-card>

            <!-- TAP OUT -->
            <v-card class="tap-card" outlined>
              <v-card-text class="pa-4">
                <div class="error--text mb-1 tap-label">TAP OUT</div>
                <div class="tap-row">
                  <span class="tap-label">Reff ID :</span>
                  <span class="tap-value">{{ editedItem.tap_data.tap_out?.rrn || '-' }}</span>
                </div>
                <div class="tap-row">
                  <span class="tap-label">Transaction Date :</span>
                  <span class="tap-value">{{ editedItem.tap_data.tap_out?.trx_datetime || '-' }}</span>
                </div>
                <div class="tap-row">
                  <span class="tap-label">Amount :</span>
                  <span class="tap-value">{{ editedItem.tap_data.tap_out?.amount || '-' }}</span>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>

export default {
  components: { DataDetailRow: () => import('@components/detail/DataDetailRow.vue') },
  props: ['editedItem'],
  computed: {
    shouldShowAmountType() {
      return this.editedItem.product_indicator !== 'N001' && this.editedItem.product_indicator !== 'N005';
    }
  },
  data: () => ({
    dialogMerchant: false,
  }),
  methods: {
    close() {
      this.$emit('closeParent');
    },
  },
};
</script>

<style scoped>
.tap-data-wrapper {
  max-width: 550px;
}

.tap-card {
  border: 1px solid #e0e0e0 !important;
}

.tap-label {
  font-weight: 600;
  font-size: 14px;
}

.tap-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.tap-label {
  color: #666;
  font-size: 13px;
  font-weight: 500;
}

.tap-value {
  color: #333;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
}
</style>
